(() => {
  const ROOT_SELECTOR = '[data-jm-homepage]';
  const INITIALIZED = 'jmHomepageInitialized';

  const pushEvent = (eventName, detail = {}) => {
    if (!Array.isArray(window.dataLayer)) return;
    window.dataLayer.push({
      event: eventName,
      jm_location: 'homepage_2_0',
      ...detail
    });
  };

  const setVoiceStatus = (status, message, state = 'info') => {
    if (!status) return;
    status.hidden = false;
    status.dataset.state = state;
    status.textContent = message;
  };

  const initializeVoice = (root) => {
    const button = root.querySelector('[data-jm-voice-button]');
    const input = root.querySelector('[data-jm-search-input]');
    const status = root.querySelector('[data-jm-voice-status]');
    const label = root.querySelector('[data-jm-voice-label]');
    const Recognition = window.SpeechRecognition || window.webkitSpeechRecognition;

    if (!button || !input || !status || !Recognition) return;

    button.hidden = false;

    let recognition = null;
    let isListening = false;

    const resetButton = () => {
      isListening = false;
      button.setAttribute('aria-pressed', 'false');
      if (label) label.textContent = 'Speak your RC model';
    };

    button.addEventListener('click', () => {
      if (isListening && recognition) {
        recognition.stop();
        return;
      }

      recognition = new Recognition();
      recognition.lang = document.documentElement.lang || 'en-US';
      recognition.continuous = false;
      recognition.interimResults = false;
      recognition.maxAlternatives = 1;

      recognition.addEventListener('start', () => {
        isListening = true;
        button.setAttribute('aria-pressed', 'true');
        if (label) label.textContent = 'Stop listening';
        setVoiceStatus(status, 'Listening… say your RC brand and model.');
        pushEvent('jm_voice_search_start');
      });

      recognition.addEventListener('result', (event) => {
        const transcript = event.results?.[0]?.[0]?.transcript?.trim();
        if (!transcript) {
          setVoiceStatus(
            status,
            'We did not catch that. Try again or type your RC model.',
            'error'
          );
          return;
        }

        input.value = transcript;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.focus();
        setVoiceStatus(
          status,
          'Review the recognized model before searching.'
        );
        pushEvent('jm_voice_search_transcript_ready');
      });

      recognition.addEventListener('error', (event) => {
        const denied = event.error === 'not-allowed' || event.error === 'service-not-allowed';
        setVoiceStatus(
          status,
          denied
            ? 'Microphone unavailable. Type your model or use your device keyboard’s dictation.'
            : 'We did not catch that. Try again or type your RC model.',
          'error'
        );
        pushEvent('jm_voice_search_error', {
          jm_voice_error: denied ? 'permission_denied' : 'recognition_error'
        });
      });

      recognition.addEventListener('end', resetButton);

      try {
        recognition.start();
      } catch (error) {
        resetButton();
        setVoiceStatus(
          status,
          'Microphone unavailable. Type your model or use your device keyboard’s dictation.',
          'error'
        );
      }
    });
  };

  const initializeRoot = (root) => {
    if (!root || root.dataset[INITIALIZED] === 'true') return;
    root.dataset[INITIALIZED] = 'true';

    root.querySelectorAll('[data-jm-search-form]').forEach((form) => {
      form.addEventListener('submit', () => {
        pushEvent('jm_search_submit', {
          jm_search_method: 'typed_or_confirmed_voice'
        });
      });
    });

    root.querySelectorAll('[data-jm-cta]').forEach((link) => {
      link.addEventListener('click', () => {
        pushEvent('jm_cta_click', {
          jm_cta_id: link.dataset.jmCta || 'unknown'
        });
      });
    });

    initializeVoice(root);
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll(ROOT_SELECTOR).forEach(initializeRoot);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeAll(event.target);
  });
})();
